import { lazy, Suspense, type ReactNode } from 'react'
import { QueryClientProvider } from '@tanstack/react-query'
import { queryClient } from '@/shared/lib/queryClient'
import { Spinner, Toaster } from '@/shared/components/ui'
import { ThemeProvider } from '@/shared/features/theme/ThemeProvider'
import { HelpProvider } from '@/shared/features/help/HelpContext'
import { isHelpAvailable } from '@/shared/features/help/helpAvailability'

// Loaded only where help is shown, so the admin bundle does not carry the
// hotel help articles.
const HelpDrawer = lazy(() =>
  import('@/shared/features/help/HelpDrawer').then((m) => ({ default: m.HelpDrawer })),
)

interface AppProps {
  router: ReactNode
}

export default function App({ router }: AppProps) {
  return (
    <ThemeProvider>
      <QueryClientProvider client={queryClient}>
        <HelpProvider>
          <Suspense
            fallback={
              <div className="flex min-h-screen items-center justify-center bg-brand-canvas">
                <Spinner size="lg" className="text-brand-orange" />
              </div>
            }
          >
            {router}
          </Suspense>
          {isHelpAvailable() && (
            <Suspense fallback={null}>
              <HelpDrawer />
            </Suspense>
          )}
          <Toaster />
        </HelpProvider>
      </QueryClientProvider>
    </ThemeProvider>
  )
}
